import {
	ClientFinancialPlanExpenseNameEnum,
	ClientFinancialPlanExpenseTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const ExpenseNamesByType: Record<
	ClientFinancialPlanExpenseTypeEnum,
	ClientFinancialPlanExpenseNameEnum[]
> = {
	[ClientFinancialPlanExpenseTypeEnum.Housing]: [
		ClientFinancialPlanExpenseNameEnum.Total,
		ClientFinancialPlanExpenseNameEnum.Rent,
		ClientFinancialPlanExpenseNameEnum.EnergyBills,
		ClientFinancialPlanExpenseNameEnum.Fees,
		ClientFinancialPlanExpenseNameEnum.OtherHousing,
	],
	[ClientFinancialPlanExpenseTypeEnum.Traffic]: [
		ClientFinancialPlanExpenseNameEnum.Total,
		ClientFinancialPlanExpenseNameEnum.Leasing,
		ClientFinancialPlanExpenseNameEnum.TollFees,
		ClientFinancialPlanExpenseNameEnum.CarInsurance,
		ClientFinancialPlanExpenseNameEnum.FuelExpenses,
		ClientFinancialPlanExpenseNameEnum.Maintenance,
		ClientFinancialPlanExpenseNameEnum.Fares,
	],
	[ClientFinancialPlanExpenseTypeEnum.Saving]: [
		ClientFinancialPlanExpenseNameEnum.Total,
		ClientFinancialPlanExpenseNameEnum.BuildingSavings,
		ClientFinancialPlanExpenseNameEnum.PensionProducts,
		ClientFinancialPlanExpenseNameEnum.Investments,
	],
	[ClientFinancialPlanExpenseTypeEnum.Insurance]: [
		ClientFinancialPlanExpenseNameEnum.Total,
		ClientFinancialPlanExpenseNameEnum.LifeInsurance,
		ClientFinancialPlanExpenseNameEnum.HouseholdInsurance,
		ClientFinancialPlanExpenseNameEnum.Responsibility,
	],
	[ClientFinancialPlanExpenseTypeEnum.Household]: [
		ClientFinancialPlanExpenseNameEnum.Total,
		ClientFinancialPlanExpenseNameEnum.FoodExpenses,
		ClientFinancialPlanExpenseNameEnum.PocketMoney,
		ClientFinancialPlanExpenseNameEnum.Hairdressing,
		ClientFinancialPlanExpenseNameEnum.Clothing,
		ClientFinancialPlanExpenseNameEnum.Sport,
		ClientFinancialPlanExpenseNameEnum.Culture,
		ClientFinancialPlanExpenseNameEnum.Restaurants,
		ClientFinancialPlanExpenseNameEnum.Pets,
		ClientFinancialPlanExpenseNameEnum.Books,
		ClientFinancialPlanExpenseNameEnum.MobilePhone,
		ClientFinancialPlanExpenseNameEnum.TuitionFees,
		ClientFinancialPlanExpenseNameEnum.Gifts,
		ClientFinancialPlanExpenseNameEnum.Vacation,
		ClientFinancialPlanExpenseNameEnum.Subscription,
	],
	[ClientFinancialPlanExpenseTypeEnum.Taxes]: [
		ClientFinancialPlanExpenseNameEnum.Total,
		ClientFinancialPlanExpenseNameEnum.SocialTax,
		ClientFinancialPlanExpenseNameEnum.IncomeTax,
		ClientFinancialPlanExpenseNameEnum.PropertyTax,
	],
	[ClientFinancialPlanExpenseTypeEnum.Other]: [
		ClientFinancialPlanExpenseNameEnum.Total,
		ClientFinancialPlanExpenseNameEnum.CharityContributions,
		ClientFinancialPlanExpenseNameEnum.RegularCleaning,
		ClientFinancialPlanExpenseNameEnum.AlimonyPayments,
		ClientFinancialPlanExpenseNameEnum.Babysitter,
		ClientFinancialPlanExpenseNameEnum.Other,
		ClientFinancialPlanExpenseNameEnum.Loans,
		ClientFinancialPlanExpenseNameEnum.Cigarettes,
	],
};
